import { DateRangePicker, Input, Select, Text, type TypeSelectOption } from '@thefarmersfront/kitchen';

import { clsx } from 'clsx';

import { SearchFilter } from '~/components/common';

import { KEYWORD_PLACE_HOLDER } from '~/constants/claim';

import type {
  TypeReturnSearchFilterOptions,
  TypeReturnSearchFilterValues,
  TypeReturnSearchFilterValuesState,
} from '~/types/claim.types';

import styles from './ClaimReturnFilter.module.scss';

const ClaimReturnFilter = ({
  options,
  values,
  valuesState,
  onChange,
  onChangeStatus,
  onSearch,
  onReset,
}: {
  options: TypeReturnSearchFilterOptions;
  values: TypeReturnSearchFilterValues;
  valuesState: TypeReturnSearchFilterValuesState;
  onChange: (values: Partial<TypeReturnSearchFilterValues>) => void;
  onChangeStatus: (values: Partial<TypeReturnSearchFilterValuesState>) => void;
  onSearch: () => void;
  onReset: () => void;
}) => {
  return (
    <SearchFilter formId="claim-return-search-form" onSubmit={onSearch} onReset={onReset}>
      <div className={clsx(styles['filter-container'], styles['filter-keyword'])}>
        <Text size="small" weight="semi-bold" element="p">
          키워드
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={options.keyword}
            value={values.keywordType}
            onChange={(_: unknown, value: TypeSelectOption<string>) => {
              if (value?.value === values.keywordType?.value) return;
              onChange({ keywordType: value, keyword: '' });
              onChangeStatus({ keyword: 'default' });
            }}
          />
          <Input
            type="text"
            size="small"
            placeholder={KEYWORD_PLACE_HOLDER[values.keywordType?.value as keyof typeof KEYWORD_PLACE_HOLDER] || '입력'}
            value={values.keyword}
            status={valuesState.keyword}
            onChange={(e) => onChange({ keyword: e.target.value })}
            onBlur={(e) => onChange({ keyword: e.target.value.trim() })}
            onFocus={() => onChangeStatus({ keyword: 'default' })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-date'])}>
        <Text size="small" weight="semi-bold" element="p">
          접수일
        </Text>
        <div className={styles['input-container']}>
          <DateRangePicker
            size="small"
            placeholder={{ start: '시작일', end: '종료일' }}
            value={values.returnDate}
            status={valuesState.returnDate}
            onChange={(value) => {
              onChange({ returnDate: value as { start: Date; end: Date } | null });
            }}
            onFocus={() => onChangeStatus({ returnDate: 'default' })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-status'])}>
        <Text size="small" weight="semi-bold" element="p">
          반품상태
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={options.returnStatus}
            value={values.returnStatus}
            onChange={(_: unknown, value: TypeSelectOption<string>) => onChange({ returnStatus: value })}
          />
        </div>
      </div>
    </SearchFilter>
  );
};

export default ClaimReturnFilter;
